<template>
    <div>
        <el-form-item label="编号" v-show="false">
            <el-input v-model="id"></el-input>
        </el-form-item>
        <el-form-item label="名称">
            <el-input v-model="name"></el-input>
        </el-form-item>
        <el-form-item label="表单标识" v-show="false">
            <el-input v-model="formKey"></el-input>
        </el-form-item>
        <el-form-item label="远程服务实例">
            <el-select v-model= "remoteInvocationModel.serviceId" filterable placeholder="请选择" style="margin-right:4px">
                <el-option
                v-for=" p in services"
                :key="p"
                :label="p"
                :value="p">
                </el-option>
            </el-select>
        </el-form-item>
         <el-form-item label="远程请求URI">
            <el-input v-model="remoteInvocationModel.remoteCallUri"></el-input>
        </el-form-item>
    </div>
</template>
<script>
import bpmnHelper from './js/helper/BpmnHelper';
//import { processReq } from '../../assets/js/public'; 
export default {
    props: ['element'],
    inject: ['bpmnModeler'],
    data(){
        return {
            id : this.element.id || '',
            name:'',
            formKey:'',
            services:[],
            remoteInvocationModel:{
                    serviceId:'',
                    remoteCallUri:''
            },
            documentation:'',
        }
    },
    mounted() {
        this.loadService();
        this.loadRemoteInvocationModel();
    },
    methods:{
        // 加载服务实例
        loadService(){
            try {
                // this.reqGet(processReq.serviceInstances,{}, (result) => {
                //     this.services = result;
                // });
            }catch(e){
                console.log('加载远程服务实例异常：'+e);
            }
        },
        // 初始化远程调用服务
        loadRemoteInvocationModel(){
                const { businessObject } = this.element;
                if(businessObject){
                    let remoteInvocation = this.element.businessObject.remoteInvocation;
                    if(remoteInvocation){
                        this.remoteInvocationModel = JSON.parse(remoteInvocation);
                    }       
                }
        }
    },
    watch: {
        id: function(newVal, oldVal) {
            const bpmnModeler = this.bpmnModeler();
            const modeling = bpmnModeler.get('modeling')
            modeling.updateProperties(this.element,{
                id: newVal
            })
        },
        name: function(newVal, oldVal) {
            const bpmnModeler = this.bpmnModeler();
            const modeling = bpmnModeler.get('modeling')
            modeling.updateProperties(this.element,{
                name: newVal
            })
        },
        'remoteInvocationModel.serviceId':function(newVal, oldVal){
            const bpmnModeler = this.bpmnModeler();
            const modeling = bpmnModeler.get('modeling')
            modeling.updateProperties(this.element,{
                'remoteInvocation': JSON.stringify(this.remoteInvocationModel)
            })
        },
        'remoteInvocationModel.remoteCallUri':function(newVal, oldVal){
            const bpmnModeler = this.bpmnModeler();
            const modeling = bpmnModeler.get('modeling')
            modeling.updateProperties(this.element,{
                'remoteInvocation': JSON.stringify(this.remoteInvocationModel)
            })
        },
        element: {
            handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    if(newVal.type === 'bpmn:EndEvent') { // 防止修改其他子组件的属性
                        this.name = newVal.name;
                    }
                }
            },
            immediate: true,
            deep: true
        },
    }
}
</script>
<style>

</style>